'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFieldGroupStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  disabled: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),

  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  disabled: false,
  fullWidth: false,
  colorScheme: 'neutral'
};
/** PROP RECEIVERS */

var size = function size(_ref) {
  var fullWidth = _ref.fullWidth;
  var align = fullWidth ? 'center' : 'stretch';
  return 'align-items: ' + align + ';';
};

var textfieldStyle = function textfieldStyle(_ref2) {
  var disabled = _ref2.disabled,
      focus = _ref2.focus,
      colorScheme = _ref2.colorScheme,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.textfield.textfield.state;
  var neutralStyles = (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source.backgroundColor, source.fontColor, source.borderColor, source.borderStyle, source.hover.backgroundColor, source.hover.fontColor, source.hover.borderColor, source.hover.borderStyle);
  var focusStyles = (0, _styledComponents.css)(['outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';'], source.focus.backgroundColor, source.focus.fontColor, source.focus.borderColor, source.focus.borderStyle);
  var disabledStyles = (0, _styledComponents.css)(['cursor:default;user-select:none;&,&:hover,&:focus{background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;}'], source.disabled.backgroundColor, source.disabled.fontColor, source.disabled.borderColor, source.disabled.borderStyle);
  var styles = null;
  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral' && !focus && !disabled) styles = neutralStyles;else if (colorScheme === 'neutral' && focus && !disabled) styles = focusStyles;else {
    styles = (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;&:hover,&:focus{background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle, source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle);
  }
  return styles;
};

var textfieldBorder = function textfieldBorder(_ref3) {
  var bordered = _ref3.bordered,
      fullWidth = _ref3.fullWidth,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = bordered ? theme.reactackle.components.textfield.textfield.bordered : theme.reactackle.components.textfield.textfield.underlined;
  var borderWidth = (0, _reactackleCore.getValueString)(source.borderWidth),
      borderRadius = (0, _reactackleCore.getValueString)(source.borderRadius);
  return bordered ? (0, _styledComponents.css)(['border-width:', ';border-radius:', ';'], fullWidth ? '0' : borderWidth, borderRadius) : (0, _styledComponents.css)(['border-width:0;border-bottom-width:', ';border-radius:', ';'], fullWidth ? '0' : borderWidth, borderRadius);
};
/** STYLES */

/** ex textfield-item-box */


var TextFieldGroupStyled = exports.TextFieldGroupStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TextFieldGroupStyled'
})(['display:flex;position:relative;max-width:100%;flex-grow:1;', ';', ';', ';', ';'], size, textfieldStyle, textfieldBorder, (0, _reactackleCore.transition)('border-color, border-style'));

TextFieldGroupStyled.propTypes = propTypes;
TextFieldGroupStyled.defaultProps = defaultProps;
TextFieldGroupStyled.displayName = 'TextFieldGroupStyled';